const NaCountryCodeKeys = {
  TITLE: 'title',
  CODE: 'code',
  DESCRIPTION_EN: 'descriptionEn',
  ACTIVE: 'active',
  INDICATOR: 'indicator',
  INTLCODE: 'intlcode',
  Validations: {
    MAX_LENGTH_5:   'validations.maxLength5',
    MAX_LENGTH_10:  'validations.maxLength10',
    MAX_LENGTH_100: 'validations.maxLength100',
    REQUIRED:       'validations.required',
  }
}

export default NaCountryCodeKeys
